<template>
         <!-- About Section -->
    <section id="about" class="about section">

<div class="container">
  <div class="row align-items-xl-center gy-5">

    <div class="col-xl-5 content">
      <h3>A propos</h3>
      <h2>Comment faire les paiements en ligne grâce à E-SOGEMA</h2>
      <p>Payez vos loyer et vos dettes pour bénéficier d'un avantage certain dans les nouveaux marchés du Bénin.</p>
      <router-link to="/e-processus" class="read-more"><span>Payer</span><i class="bi bi-arrow-right"></i></router-link>
    </div>

    <div class="col-xl-7">
      <div class="row gy-4 icon-boxes">
        <div class="col-md-6">
          <div class="icon-box">
            <i class="bi bi-buildings"></i>
            <h3>Identification </h3>
            <p>Retrouver votre emplacement et découvrer exactement ce que vous devez auprès de la SOGEMA</p>
          </div>
        </div> <!-- End Icon Box -->

        <div class="col-md-6">
          <div class="icon-box">
            <i class="bi bi-clipboard-pulse"></i>
            <h3>Choix des impayés</h3>
            <p>Choississez les impayés que vous désirez payer et passez à l'étape suivante</p>
          </div>
        </div> <!-- End Icon Box -->

        <div class="col-md-6" data-aos-delay="400">
          <div class="icon-box">
            <i class="bi bi-command"></i>
            <h3>Procéder au paiement </h3>
            <p>Valider le paiement en ligne avec un agrégateur de votre choix</p>
          </div>
        </div> <!-- End Icon Box -->

        <div class="col-md-6" data-aos-delay="500">
          <div class="icon-box">
            <i class="bi bi-graph-up-arrow"></i>
            <h3>Obtenez un reçu de paiement</h3>
            <p>Recevez un reçu de paiement pour confirmer que votre paiement a été encaissé. Vous devrez bien concerver ce reçu</p>
          </div>
        </div>

      </div>
    </div>

  </div>
</div>
</section><!-- /About Section -->
</template>
<script lang="ts">
	import { defineComponent,onMounted } from "vue";

	export default defineComponent({
		name: "SectionOne",
		components: {},
		setup() {
			//
		}		
	});
</script>